/**
 * URL del endpoint de chat.
 * - Local: backend Node en http://localhost:3001/api/chat
 * - Producción (Vercel + Supabase): URL de la Edge Function, ej.
 *   https://TU_PROJECT_REF.supabase.co/functions/v1/chat
 * Configurar en Vercel como variable de entorno: REACT_APP_CHAT_API_URL
 */
export const CHAT_API_URL =
  process.env.REACT_APP_CHAT_API_URL || "http://localhost:3001/api/chat";
